// extracted by mini-css-extract-plugin
export default {"tabs":"LanguageTabs_tabs__O9WoI","tab":"LanguageTabs_tab__TC+WG","active":"LanguageTabs_active__yj0o8"};